import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import { getTextColorsFromSection } from '../lib/colors';
import GridSection from '../GridSection';
import Section, { SectionTitle } from '../Section';
import TypographyDraft from '../TypographyDraft';
import mapBy from '../lib/mapBy';

function SponsorsSection({ classes, event, site, section }) {
  const { data, styles } = section;
  const colors = getTextColorsFromSection(site, section);

  const getSponsorClasses = ({ sections, sectionIds }, section, classes) => {
    const sponsorClasses = [classes.root];
    const sectionPosition = sectionIds.indexOf(section.id);
    const mappedSections = mapBy(sections, 'id');

    const sectionBefore = mappedSections[sectionIds[sectionPosition - 1]];
    if (sectionBefore && sectionBefore.type !== 'sponsors') {
      sponsorClasses.push(classes.paddingTop);
    }

    const sectionAfter = mappedSections[sectionIds[sectionPosition + 1]];
    if (sectionAfter && sectionAfter.type !== 'sponsors') {
      sponsorClasses.push(classes.paddingBottom);
    }

    return sponsorClasses.join(' ');
  };

  const rootClasses = getSponsorClasses(site, section, classes);

  return (
    <Section site={site} section={section} className={rootClasses}>
      {!data.hideTitle && (
        <SectionTitle
          className={classes.title}
          title={data.title}
          style={{ ...colors.title, ...styles.title }}
        />
      )}
      <TypographyDraft
        component="h3"
        className={classes.subtitle}
        style={{ ...colors.title, ...styles.category }}
        data={data.subtitle}
      />
      <GridSection
        event={event}
        site={site}
        section={{
          id: section.id,
          data: { items: section.data.items },
          styles: section.styles,
        }}
        withPadding={false}
        hideTitle
        imageRatio={2}
      />
    </Section>
  );
}

SponsorsSection.propTypes = {
  classes: PropTypes.object.isRequired,
  event: PropTypes.object.isRequired,
  site: PropTypes.object.isRequired,
  section: PropTypes.object.isRequired,
};

const stylesheet = theme => ({
  root: {
    padding: `0 ${theme.spacing.large}px`,
  },
  paddingTop: {
    paddingTop: theme.spacing.xlarge,
  },
  paddingBottom: {
    paddingBottom: theme.spacing.xlarge,
  },
  title: {
    marginTop: 4 * theme.spacing.unit,
    marginBottom: 2 * theme.spacing.unit,
    textAlign: 'center',
  },
  subtitle: {
    marginTop: 4 * theme.spacing.unit,
    marginBottom: 2 * theme.spacing.unit,
    textAlign: 'center',
  },
});

export default injectSheet(stylesheet)(SponsorsSection);



// WEBPACK FOOTER //
// ./src/site-render/src/SponsorsSection/SponsorsSection.js